/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import { Divider } from "@material-ui/core";
//custom libraries
import { Button } from "../components";

interface DialogOptions {
  onConfirm: Function;
  onCancel: Function;
  heading?: any;
  confirmLabel?: string;
  cancelLabel?: string;
  [extraProps: string]: any;
}

const ConformDialogBox: React.FC<DialogOptions> = ({
  onConfirm,
  onCancel,
  heading,
  confirmLabel,
  cancelLabel,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Dialog
        open={!!heading}
        onClose={() => {
          onCancel();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">
          {heading?.key ? t(heading.key, heading.params) : t(heading)}
        </DialogTitle>
        <Grid item>
          <Divider />
        </Grid>
        <DialogContent>
          <Grid
            container
            direction="row"
            justify="center"
            spacing={2}
            alignItems="center">
            <Grid item>
              <Button
                onClick={() => {
                  onConfirm();
                }}
                color="primary">
                {t(confirmLabel || "")}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => {
                  onCancel();
                }}
                color="primary"
                autoFocus>
                {t(cancelLabel || "")}
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ConformDialogBox;
